// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invSterilizationMethodEnum } from './InvSterilizationMethodEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const invSterilizationPresetId = (z.number());
export const invSterilizationPreset = z.object({
    id: invSterilizationPresetId,
    name: z.string(),
    method: invSterilizationMethodEnum,
    temperature_c: z.string().nullable(),
    hold_min: z.number().nullable(),
    display_order: z.number(),
    archived_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const invSterilizationPresetInitializer = z.object({
    id: invSterilizationPresetId.optional(),
    name: z.string(),
    method: invSterilizationMethodEnum,
    temperature_c: z.string().optional().nullable(),
    hold_min: z.number().optional().nullable(),
    display_order: z.number().optional(),
    archived_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const invSterilizationPresetMutator = z.object({
    id: invSterilizationPresetId.optional(),
    name: z.string().optional(),
    method: invSterilizationMethodEnum.optional(),
    temperature_c: z.string().optional().nullable(),
    hold_min: z.number().optional().nullable(),
    display_order: z.number().optional(),
    archived_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=InvSterilizationPreset.js.map